const initialState = {
  previewing: false,
};

export default function previewing(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
